import {
  ActivitiesState,
  ActivityHistory,
  InfoState,
  RequestState,
  SendState,
  State,
  Transfer,
} from './model';
import { CallStatusDefault, UserInfoDefault } from '../../../models';
import { IHistoricalDefault } from '../../historical/defaults';
import { TransferDialogs, TransferStatus, TransferType } from './consts';

export const TransferDefault: Transfer = {
  type: TransferType.SEND,
  status: TransferStatus.NOT_VALIDATED,
  sender: { ...UserInfoDefault },
  receiver: { ...UserInfoDefault },
  devices: [],
};

export const SendStateDefault: SendState = {
  transfer: { ...TransferDefault },
  getCustomerCall: { ...CallStatusDefault },
  validateCall: { ...CallStatusDefault },
  requestCodeCall: { ...CallStatusDefault },
  checkCodeCall: { ...CallStatusDefault },
  transferCall: { ...CallStatusDefault },
};

export const ActivityHistoryDefault: ActivityHistory = IHistoricalDefault();
export const ActivitiesStateDefault: ActivitiesState = {
  openTransfers: { ...ActivityHistoryDefault },
  closedTransfers: { ...ActivityHistoryDefault },
};

export const RequestTransferDefault: Transfer = { ...TransferDefault, type: TransferType.REQUEST };

export const RequestStateDefault: RequestState = {
  transfer: RequestTransferDefault,
  validateCall: { ...CallStatusDefault },
  createCall: { ...CallStatusDefault },
};

export const InfoStateDefault: InfoState = {
  transferId: undefined,
  devices: []
};

export const StateDefault: State = {
  screen: TransferDialogs.SEND,
  send: { ...SendStateDefault },
  activities: { ...ActivitiesStateDefault },
  request: { ...RequestStateDefault },
  info: { ...InfoStateDefault}
};

export default StateDefault;
